import { useState } from 'react';
import { Box, ListItemText, ListItem } from '@mui/material';
import BaseFieldEditor from './BaseFieldEditor';
import ConfidenceIndicator from '../ConfidenceIndicator';
import EquipmentTypeSelector from '../selectors/EquipmentTypeSelector';

// eslint-disable-next-line
const EquipmentTypeEditor = ({
  open,
  column,
  editing,
  currentlyEditing,
  setCurrentlyEditing,
  setCurrentEditor,
  actions,
}) => {
  if (!editing || editing.length <= 0) return null;
  const rawPredictions = editing[0].data?.['auto_tagger.equip_type_preds'] || '{}';
  const predictions =
    typeof rawPredictions === 'string'
      ? JSON.parse(rawPredictions.replaceAll("'", '"')) || {}
      : rawPredictions;
  const [selectedOption, setSelectedOption] = useState(editing[0].data.equip_type);

  return (
    <BaseFieldEditor
      open={open}
      onSave={() => {
        const action = actions.find((a) => a.id === column.action);
        action.doSave(editing, {
          'e.equip_type': selectedOption,
          'e.equip_type.cnf': 100,
        });
        action.doClose({ currentlyEditing, setCurrentlyEditing, column, setCurrentEditor });
      }}
      title="Equipment Type Editor"
      editing={editing}
      column={column}
      currentlyEditing={currentlyEditing}
      setCurrentlyEditing={setCurrentlyEditing}
      setCurrentEditor={setCurrentEditor}
      actions={actions}
    >
      <EquipmentTypeSelector
        value={selectedOption}
        setValue={setSelectedOption}
        sortOptions={(a, b) => {
          if (editing.length !== 1) return 0;
          const aConfidence = predictions[a.tagName] || 0;
          const bConfidence = predictions[b.tagName] || 0;
          return bConfidence - aConfidence;
        }}
        renderOption={(props, option) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <ListItem {...props}>
            <Box width="45px" height="35px">
              {editing.length === 1 && predictions[option.tagName] && (
                <ConfidenceIndicator value={predictions[option.tagName] * 100} />
              )}
            </Box>
            <ListItemText>{option.tagName}</ListItemText>
          </ListItem>
        )}
      />
    </BaseFieldEditor>
  );
};

export default EquipmentTypeEditor;
